<template>
    <div class="layadmin-tabspage-none"
    :class="[{ 'layadmin-view-sm': $store.state.style.isSmView,
                'layadmin-view-xs': !$store.state.style.isSmView,
                'layadmin-side-shrink': $store.state.style.sideShrink}, $store.state.style.currentTheme]">
        <div class="layui-layout layui-layout-admin" style="height:100%;">
            <TopBar/>
            <LeftNav/>
            <RightTabs/>
        </div>
    </div>
    
</template>

<script>
import LeftNav from "@/views/layout/LeftNav";
import RightTabs from "@/views/layout/RightTabs";
import TopBar from "@/views/layout/TopBar";
export default {
    components: {
        LeftNav,
        RightTabs,
        TopBar
    },

    mounted(){
        let _this = this;


        function debounce(fn,wait){
            let timer = null;
            return function(){
                if(timer !== null){
                    clearTimeout(timer);
                }
                timer = setTimeout(fn,wait);
            }
        }
    
        function handle(){
            let w = window.innerWidth;
            if(w < _this.$store.state.style.smallViewportSize){
                _this.$store.commit('style/setIsSmView', true);
            }else{
                _this.$store.commit('style/setIsSmView', false);
            }
        }
        
        handle();

        window.addEventListener("resize",debounce(handle,300));
        


    },

};
</script>

<style lang="less" scoped>
    .layadmin-tabspage-none{
        width: 100%;
        height: 100%;
        background: #fff;
		position: relative;
    }




/** 小视口 **/

/**  隐藏左侧菜单时  **/
.layadmin-view-sm.layadmin-side-shrink{
    #app-left-nav{
        width: 0px;

        .layui-logo{
            width: 0px;
        }

    }
}

/**  隐藏左侧菜单时 end **/


/** 小视口 end **/

</style>
